'use client';

import type { ImageTextV1Props } from '@/core/types';

import React from 'react';

import { Box, Image, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function ImageTextV1({
  title,
  titleTag = 'h2',
  description,
  image,
  buttons,
  className = '',
  infoClasses = '',
  contentClasses = '',
  imageClasses = '',
}: ImageTextV1Props) {
  const isReverse = className.includes('col-reverse');

  return (
    <section className={`relative py-[36px] md:py-[80px] ${className} `}>
      <Container>
        <Box
          className={`flex flex-col ${isReverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 md:gap-16 items-center ${contentClasses}`}
        >
          {title && (
            <Typography
              variant="h2"
              className="w-full text-left uppercase md:text-4xl font-bold mb-2 lg:mb-10 text-primary  lg:hidden"
            >
              {title}
            </Typography>
          )}

          <Box className={`w-full order-1 lg:order-none  lg:w-1/2 ${infoClasses}`}>
            {title && (
              <Typography
                variant="h2"
                component={titleTag}
                className=" uppercase md:text-[42px] font-bold mb-2 lg:mb-10 text-primary-dark hidden lg:block"
              >
                {title}
              </Typography>
            )}

            {description && (
              <Box
                className="text-base [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-4 [&>h2]:mb-1 [&>h2]:text-lg [&>h2]:font-semibold [&>h4]:mb-1 [&>h4]:text-md [&>h4]:font-medium"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}

            {buttons && buttons.length > 0 && (
              <Box className="flex justify-start mt-2 lg:mt-8 gap-4">
                {buttons.map((button, index) => (
                  <Button
                    key={index}
                    href={button.link}
                    component={RouterLink}
                    variant={button.variant}
                    className={`min-w-[171px] md:min-w-[180px] px-2 md:px-4 text-sm md:text-base ${
                      index === 1 ? '!text-black' : ''
                    } ${button.className}`}
                  >
                    {button.text}
                  </Button>
                ))}
              </Box>
            )}
          </Box>

          <Box className={`w-full  lg:w-1/2 xl:w-2/3 ${imageClasses}`}>
            {!!image?.url && (
              <Image
                src={image?.url || ''}
                alt={image?.alt || ''}
                objectFit="contain"
                className="w-full rounded-2xl"
                width={1440}
                height={500}
                loading="eager"
              />
            )}
          </Box>
        </Box>
      </Container>
    </section>
  );
}
